import React from 'react';
import '../../../../css/common/chat/ChatComposer.css';

const resolveReplyBodyLabel = (reply) => {
  const type = String(reply?.type || '').trim().toLowerCase();
  if (type === 'file') {
    return String(reply?.fileName || 'ファイル').trim();
  }
  if (type === 'image') {
    return '画像';
  }
  return String(reply?.previewText || '').trim();
};

export default function ChatComposerReplyPreview({ reply, onCancel }) {
  if (!reply?.messageId) return null;
  return (
    <div className="chat-reply-preview" role="status" aria-live="polite">
      <div className="chat-reply-preview__body">
        <span className="chat-reply-preview__label">返信先</span>
        <span className="chat-reply-preview__sender">{String(reply?.senderName || 'メッセージ').trim()}</span>
        <span className="chat-reply-preview__text">{resolveReplyBodyLabel(reply)}</span>
      </div>
      <button
        type="button"
        className="chat-reply-preview__cancel"
        onClick={onCancel}
        aria-label="返信を取り消す"
      >
        <i className="fa-solid fa-xmark" aria-hidden="true" />
      </button>
    </div>
  );
}
